import { Component, OnInit, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-addreimbursetype',
  templateUrl: './addreimbursetype.component.html',
  styleUrls: ['./addreimbursetype.component.css']
})
export class AddreimbursetypeComponent implements OnInit,AfterViewInit {

  @ViewChildren('input')firstipcontrol;
  
formname:String="ReimburseType"; 
//Display
formmode:string="Add";

//Mode Values
isaddmode:boolean=false;
iseditmode:boolean=false;
isdeletemode:boolean=false;
isviewmode:boolean=false;

isloading: boolean = false;
isprivilage: boolean = false;
showProgress: boolean = false;


//Save Validation
submitted:boolean;
successfully:boolean;
saveloading: boolean;

//Edit Get Values
reimbursetypeColl:any=[];
reimbursetypeBO:any={};

reimbursetypeid:number=0

reimbursetypeform=new FormGroup({
  reimbursetypeid:new FormControl(0),          
  reimbursetypename:new FormControl('',Validators.required),  
 inactive:new FormControl(false),  
});


constructor(private appService: AppdataService,private loginService:LoginserviceService,private route: ActivatedRoute,
   public router: Router,private toastr: ToastrService, private productFindService: NgbModal) { 
     this.route.queryParams.subscribe(params => {
       if(params.id!==undefined){
         this.reimbursetypeid = params.id
       }          
     });

     this.fnServiceChanges();
}

 
fnServiceChanges() {
  this.loginService.serviceAuthChange.subscribe((value) => {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.fnUserFailedForm();
    }

  });
}



ngOnInit() {
  try {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.loginService.fnGetUserRoleList();
    }

  } catch (ex) {
    this.fnShowErrorMsg(ex);
  }
}

fnOnInitForm() {
   try{
       this.isaddmode=true;
       this.reimbursetypeform.reset();
       this.fnInitializeFormGroup(); 

       if(this.reimbursetypeid>0){
         this.fngetReimburseType();
       }
   }catch(ex){
     this.fnShowErrorMsg(ex);
   }
}
fnCheckUserPririvilage() {
  var _check: boolean = false;
  if (this.reimbursetypeid > 0) {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
  } else {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
  }

  return _check;
}

fnUserFailedForm() {
  this.isprivilage = true;
}
ngAfterViewInit()
{
  //this.firstipcontrol.first.nativeElement.focus();
}

fnInitializeFormGroup(){
   this.reimbursetypeform.setValue({
    reimbursetypeid:0,    
    reimbursetypename:'',
     inactive:false              
   })
}

//Get 
fngetReimburseType() { 
  if (this.showProgress) {
    return;
  }

  this.fnShowProgress();       
     var data = {
       'reimbursetypeid':this.reimbursetypeid,
       'companyid':this.loginService.fnGetCompanyId()          
     }
     this.appService.getReimburseType(data)
     .subscribe(
       (res)=>{                
         if(res.json().status===200){  
          this.fnHideProgress();

           this.reimbursetypeColl=res.json().result;
           var editdata = this.reimbursetypeColl[0];        
           this.fnEditMode(editdata);
           this.reimbursetypeBO=editdata;
         }
         else {
          this.fnHideProgress();

           this.loginService.fnAPIError(res.json())
         }
         
     },
     (err)=>{
      this.fnHideProgress();
          
       this.toastr.error('Error', err);
     })
}



//Save Btn Click
fnSaveBtnClick(){
   try{ if (this.saveloading) {
    return;
  } 
     this.submitted=true;
     this.successfully=false;
     //Validate
     if(this.reimbursetypeform.valid){this.saveloading = true;
         //Check
         var data = {
               'reimbursetypeid': this.reimbursetypeid,                      
               'reimbursetypename':this.reimbursetypeform.get('reimbursetypename').value, 
               'inactive':this.reimbursetypeform.get('inactive').value,            
               'companyid':this.loginService.fnGetCompanyId(),
               'createdby': this.loginService.fnGetModUserId(),  
              'modifiedby':this.loginService.fnGetModUserId(),                                                              
         }

       
       
         this.appService.fnCheckReimburseType(data).subscribe(
           (res)=>{
             if(res.json().status===200){  
               var _checkresult=res.json().result[0].checkfield;
             
               if(_checkresult==="done"){
                     if (this.reimbursetypeform.get('reimbursetypeid').value>0){
                       //Update 
                       this.fnSetReimburseType(data);
                     }
                     else{
                       //Insert 
                       this.fnInsertReimburseType(data);
                     }
               }
               else{        
                     if(_checkresult==="name"){ this.saveloading = false;
                       this.reimbursetypeform.controls['reimbursetypename'].setErrors({'notfound': true});
                     }
               }
             }
             else { this.saveloading = false;
               this.loginService.fnAPIError(res.json())
             }
         },
         (err)=>{ this.saveloading = false;
             this.toastr.error('Error', err);           
         });
      }
   }catch(ex){ this.saveloading = false;
     this.fnShowErrorMsg(ex);
   }
}

//Insert
fnInsertReimburseType(data){    
 
   this.appService.fnInsertReimburseType(data).subscribe(
     (res)=>{ this.saveloading = false;
       if(res.json().status===200){
      
         if(res.json().result!=""){
           this.toastr.success('', "The new reimbursetype has been added successfully.Insert Successfully");
           this.fnInsertActivityLog('INSERT', 0, data.reimbursetypename);
           this.fnCloseForm();
         }
       }
       else {
         this.loginService.fnAPIError(res.json())
       }
   },
     (err)=>{ this.saveloading = false;
       this.toastr.error('Error', err);
     });

}

//Set
fnSetReimburseType(data){    

this.appService.fnSetReimburseType(data).subscribe(
 (res)=>{ this.saveloading = false;
   if(res.json().status===200){  
         if(res.json().result!=""){
             this.toastr.success('', "The reimbursetype has been updated successfully.");
             this.fnInsertActivityLog('EDIT',this.reimbursetypeid,data.reimbursetypename);
             this.fnCloseForm();        
         } 
     }
   else {
     this.loginService.fnAPIError(res.json())
   }
 },
 (err)=>{ this.saveloading = false;
   this.toastr.error('Error', err);
 });

}

//Close
fnCloseForm(){
try{
  this.router.navigate(['/ReimburseType']);
}catch(ex){
   this.fnShowErrorMsg(ex);
}
}

private fnEditMode(deptBO){
 this.reimbursetypeform.setValue({ 
  reimbursetypeid:deptBO.reimbursetypeid,     
  reimbursetypename:deptBO.reimbursetypename,
   inactive:deptBO.inactive
 });

 this.formmode="Edit";
   
 this.iseditmode=true;
 this.isdeletemode=false;
 this.isviewmode=false;
}
fnInsertActivityLog(action,refno,desc){
  try{
    var data={
      logtype:action,
      logat:this.formname,
      refnum:refno,
      logdescr:desc,companyid: this.loginService.fnGetCompanyId(),         
      logby:this.loginService.fnGetModUserId(),
    }
  

    this.appService.fnInsertActivity(data).subscribe(
      (res)=>{
      },
      (err)=>{
     
      });

  }catch{

  }
}
private fnShowProgress() {
  this.showProgress = true;
}
private fnHideProgress() {
  this.showProgress = false;
}
private  fnShowErrorMsg(ex){
this.toastr.warning('Internal Error', ex);       
}









}
